module.exports = __webpack_public_path__ + "audio-6724d680ab90.m4a";